import React from 'react';
import  {useState, useEffect,useRef,Suspense, lazy } from 'react'
import { ChallengeTypeContainer, CharityProgressBar, CharityProgressBarFill, CommonRightCard, CompletePointCardNew, ProfileContainer, HoverIconWrapper } from './styles'
import { CalendarChallengeIcon, LocationChallengeIcon, RewardsChallengeIcon, PeopleChallengeIcon, InviteChallengeIcon, StepsIcon, CaloriesIcon, DisatanceIcon } from '../../utils/icons'
import { Divider, ManagerIconContainer, NameInitials } from '../Manager/styles'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux';
import { commaSeperator, convertDateInTimezone, convertMilesToKm, convertMonthFromDate, getInitials, getTimeToShow, rankingDashboard } from '../../utils/methods'
import moment from 'moment'
import { t } from 'i18next'
import Waiting from '../Waiting'
import { isEmpty, isNull } from 'lodash'
import LazyImage from '../common/LazyImage/LazyImage'
import { ImageUrl } from '../../utils/constants'
import {AddUserIcon, RemoveUserIcon} from '../../utils/icons'
import { joinOrLeaveChallenge,getInviteAmigosList } from '../../redux/actions'
import { useDispatch } from 'react-redux';
const  InviteAmigoPopUp = lazy (()=> import('./InviteAmigoPopUp/inviteChallengePopup'))
import {CommonButtonBorder} from '../common/commonStyles'


function CharityChallengeRightScreen({tabValue, challenge ,userId, history, onAddUserPopup, getUserOverviewDetails, role, hasCompanyInRoute }) {
  const dispatch = useDispatch();
  const challengeAttendees = useSelector((state) => state.challenges.challengeAttendees);
  const userChallengeDetails = useSelector((state) => state.challenges.userChallengeDetails);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const [showInviteAmigoPopup, setShowInviteAmigoPopup] = useState(false)
  let lang = localStorage.getItem("lang");

  const [time, setTime] = useState(getTimeToShow(challenge, 'challenge'));
  const intervalRef = useRef(null);

  // window.console.log("userChallengeDetails", userChallengeDetails); 

  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setTime(getTimeToShow(challenge, 'challenge'));
    }, 1000);

    return () => {
      window.clearInterval(intervalRef.current);
    };
  }, [challenge]);



  useEffect(() => {
    if (challenge?.id && challenge?.event_type && userId) {
      getUserOverviewDetails(challenge.id, challenge.event_type, userId);
    }
  }, [challenge?.id, challenge?.event_type, userId]);


  useEffect(() => {
    if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
    }

    intervalRef.current = window.setInterval(() => {
      setTime(getTimeToShow(challenge, 'challenge'));
    }, 1000);

    return () => window.clearInterval(intervalRef.current);
  }, [challenge]);


  const showHideInviteAmigoPopup = () => {
    const updatedPopupState = !showInviteAmigoPopup;
    setShowInviteAmigoPopup(updatedPopupState);

    if (updatedPopupState) {
      dispatch(getInviteAmigosList(userId, challenge.id));
    }
  };

  const hideInviteAmigoPopup = () => {
    setShowInviteAmigoPopup(false);
  };


  let challengeOver = true;
  time.map((step) => {
    const values = step.split(' ');
    if (values && parseInt(values[0], 10) > 0) {
      challengeOver = false;
    }
  });
  let challengeCompetitors = {};

  let propsChallengeCompetitors = [];
  const joinOrLeave = (challenge.id !== 53) ? !challengeOver && (challenge.challenge_status === 'joined' ? 0 : 1) : (challenge.challenge_status === 'joined' ? 0 : 1);


  if (challenge.challenge_type === 'new_group') {
    const { user_details: userDetails } = userChallengeDetails;
    propsChallengeCompetitors = userDetails;
  } else {
    propsChallengeCompetitors = userChallengeDetails['user_details'];
  }

  const valid = convertDateInTimezone(challenge.end_date)._d >= moment()._d;

  if (challenge.challenge_status !== 'over' || valid) {
    challengeCompetitors = propsChallengeCompetitors;
  } else if (userChallengeDetails) {
    challengeCompetitors = propsChallengeCompetitors;
  }



  let today = moment()._d;
  let startDay = convertDateInTimezone(challenge.start_date)._d;

  const CurrentDay = moment(); // current moment
  const ChallengestartDay = moment(convertDateInTimezone(challenge.start_date));
  let daysRemaining = Math.ceil(ChallengestartDay.diff(CurrentDay, 'hours') / 24);
  const lastDayToJoin = challenge?.last_date_to_join
    ? moment(convertDateInTimezone(challenge?.last_date_to_join)._d)
    : null;

  const isPastJoinDate = lastDayToJoin ? CurrentDay.isAfter(lastDayToJoin, 'day') : false;
  const buttonStatus = challenge.is_user_allowed_to_join ? true : false;


  let daysDifference = challenge && (new Date(challenge.end_date) - new Date(challenge.start_date)) / (1000 * 60 * 60 * 24);
  const DistanceUnit = localStorage.getItem('DISTANCE');

  let Last_Day = challenge.last_date_to_join !== null ? (convertMonthFromDate(moment(convertDateInTimezone(challenge?.last_date_to_join)._d).format(' MMMM D, YYYY'), t)) : null;
  const joinChallenge = (challengeId, isJoined) => {
    setIsButtonDisabled(true);
    window.setTimeout(() => {
      setIsButtonDisabled(false);
    }, 2000);
    const data = {
      challenge_id: challengeId,
      is_joined: isJoined
    };
    dispatch(joinOrLeaveChallenge(data));
  };


  const { team_details: teamdetails } = userChallengeDetails || {};

  if (!userChallengeDetails || Object.keys(userChallengeDetails).length === 0 || isEmpty(teamdetails)) {
    return <Waiting />;
  }

  const TeamDetails = teamdetails;

  const ChallengeType = challenge.event_type;
  const activityType = ChallengeType === 'Total Distance' ? 'distance' : ChallengeType === 'Total Steps' ? 'steps' : 'calories';

  if ((!(userChallengeDetails) || !userId)) {
    return <Waiting />
  } else {
    return (
      <>
        <CommonRightCard isMargin={"0px 0px 28px 0px"}>

          {
            challenge.challenge_status == 'over' && !isEmpty(challengeCompetitors) && challengeCompetitors ?
              <CompletePointCardNew>
                <div className='width'>{"Your company recorded a whopping"} {challenge.event_type === 'Total Steps' ? `${commaSeperator(challengeCompetitors['steps'])} ${("Steps")}` : challenge.event_type === 'Total Calories' ? `${commaSeperator(challengeCompetitors['calories'])} calories` : `${commaSeperator(challengeCompetitors['distance'])} Miles`}&nbsp;{"in just"} {`${Math.floor(daysDifference)}`} {Math.floor(daysDifference) > 1 ? "Days" : "Day"} {"earning"}&nbsp;{challenge?.rewarded_points} Points! </div>
                {/* <div className='width'><div>{Math.floor(daysDifference) > 1 ? "Days" : "Day"} {"earning"}&nbsp;{challenge.challenge_point} Points!</div></div> */}
              </CompletePointCardNew> :
              challenge.is_joined !== 1 && challenge.challenge_status == 'over' ?
                <CompletePointCardNew>
                  <div className='width'>Challenge Completed!
                  </div>
                </CompletePointCardNew> :

                challenge.is_joined !== 1 ?
                  <div className={isPastJoinDate || !buttonStatus ? "disableButton" : "jointButton"} onClick={isButtonDisabled || isPastJoinDate || !buttonStatus  ? null : () => joinChallenge(challenge.id, joinOrLeave)}>Join Challenge</div> : null}

          {(challenge.challenge_status == 'joined' && today < startDay) && !isEmpty(challengeCompetitors) && challengeCompetitors ?
            <CompletePointCardNew>
              <div className='width'>{`Just ${daysRemaining} days to go until your challenge begins!`}
              </div>
            </CompletePointCardNew> : null}


          {(challenge.challenge_status === 'joined' && today >= startDay) && !isEmpty(challengeCompetitors) && challengeCompetitors &&
            <ProfileContainer>

              {((tabValue === 1) || (tabValue === 3) || (tabValue === 2 && challenge.is_team_challenge !== 1)) && (<div style={{ display: "flex", gap: "20px" }}>
                {challengeCompetitors['profile_image'] !== "profile-Image/default.png" ?
                  <LazyImage
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "48px",
                      border: "1px solid  #DCDCDC",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    src={`${ImageUrl}/${challengeCompetitors['profile_image']}`
                    }
                  />
                  :
                  <NameInitials id="name-initials">
                    {getInitials(challengeCompetitors?.fullname)}
                  </NameInitials>
                }
                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  <div className="challengeNameContainer">Hi, {challengeCompetitors?.fullname}</div>
                  <div className="challengeMessage">Here’s what you accomplished today</div>
                </div>
              </div>)}

              {(tabValue === 2 && challenge.is_team_challenge === 1) &&
                (<div style={{ display: "flex", gap: "20px" }}>
                  {(challenge?.team_challenge_details?.team_details?.logo !== "profile-Image/default.png" && challenge?.team_challenge_details?.team_details?.logo) ?
                    <LazyImage
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "48px",
                        border: "1px solid  #DCDCDC",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                      src={`${ImageUrl}/${challenge?.team_challenge_details?.team_details?.logo}`
                      }
                    />
                    :
                    <NameInitials id="name-initials">
                      {getInitials(challenge?.team_challenge_details?.team_details?.name)}
                    </NameInitials>
                  }
                  <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                    <div className="challengeNameContainer">Hi, {challenge?.team_challenge_details?.team_details?.name}</div>
                    <div className="challengeMessage">Here’s your team ranking summary</div>
                  </div>
                </div>)}

              {tabValue !== 2 ? <Divider id="divider" isMargin={"20px 0px"}></Divider> : null}

              {(tabValue === 2 && challenge.is_team_challenge === 0) ?
                <div className="leaderboardConatainer">
                  {(challenge.challenge_status === 'joined' || challenge.challenge_status === 'over') && !isEmpty(challengeCompetitors) && challenge.event_type === 'Total Steps' ?
                    (<div className="challengeDetails profileSubContainer">
                      <ChallengeTypeContainer isBackgroundColor="#92A4DA" >{StepsIcon()}</ChallengeTypeContainer>
                      {isNull(challengeCompetitors['user_rank']) ? <div className="rankText">Rank: 0</div> :
                        (today < startDay) ? <div className="rankText">-</div> :
                          <div className="rankText">Rank: {challengeCompetitors['user_rank']}{rankingDashboard(challengeCompetitors['user_rank'] - 1)}</div>}
                      <div className="challengeTypesUnit"> {challengeCompetitors['steps'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challengeCompetitors['steps'])} Steps
                      </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                    </div>) :
                    challenge.event_type === 'Total Calories' ?
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#B1AA56">{CaloriesIcon()}</ChallengeTypeContainer>
                        {isNull(challengeCompetitors['user_rank']) ? <div className="rankText">Rank: 0</div> :
                          (today < startDay) ? <div className="rankText">-</div> :
                            <div className="rankText">Rank: {challengeCompetitors['user_rank']}{rankingDashboard(challengeCompetitors['user_rank'] - 1)}</div>}
                        <div className="challengeTypesUnit">  {challengeCompetitors['calories'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challengeCompetitors['calories'])} Calories
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>) :
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#DA6C74">{DisatanceIcon()}</ChallengeTypeContainer>

                        {isNull(challengeCompetitors['user_rank']) ? <div className="rankText">Rank: 0</div> :
                          (today < startDay) ? <div className="rankText">-</div> :
                            <div className="rankText">Rank: {challengeCompetitors['user_rank']}{rankingDashboard(challengeCompetitors['user_rank'] - 1)}</div>}

                        <div className="challengeTypesUnit"> {challengeCompetitors['distance'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{DistanceUnit === "KILOMETER" ? `${commaSeperator(convertMilesToKm(challengeCompetitors['distance']))} Km` : `${commaSeperator(challengeCompetitors['distance'])} Miles`}
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>)}
                </div> :

                (tabValue === 2 && challenge.is_team_challenge === 1) ?
                  <div className="leaderboardConatainer">
                    {(challenge.challenge_status === 'joined' || challenge.challenge_status === 'over') && !isEmpty(challenge?.team_challenge_details) && challenge.event_type === 'Total Steps' ?
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#92A4DA" >{StepsIcon()}</ChallengeTypeContainer>
                        {isNull(challenge?.team_challenge_details?.team_details?.team_position) ? <div className="rankText">Rank: 0</div> :
                          (today < startDay) ? <div className="rankText">-</div> :
                            <div className="rankText">Rank: {challenge?.team_challenge_details?.team_details?.team_position}{rankingDashboard(challenge?.team_challenge_details?.team_details?.team_position - 1)}</div>}
                        <div className="challengeTypesUnit"> {challenge?.team_challenge_details?.team_details?.team_contribution !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challenge?.team_challenge_details?.team_details?.team_contribution)} Steps
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>) :
                      challenge.event_type === 'Total Calories' ?
                        (<div className="challengeDetails profileSubContainer">
                          <ChallengeTypeContainer isBackgroundColor="#B1AA56">{CaloriesIcon()}</ChallengeTypeContainer>
                          {isNull(challenge?.team_challenge_details?.team_details?.team_position) ? <div className="rankText">Rank: 0</div> :
                            (today < startDay) ? <div className="rankText">-</div> :
                              <div className="rankText">Rank: {challenge?.team_challenge_details?.team_details?.team_position}{rankingDashboard(challenge?.team_challenge_details?.team_details?.team_position - 1)}</div>}
                          <div className="challengeTypesUnit">  {challenge?.team_challenge_details?.team_details?.team_contribution !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challenge?.team_challenge_details?.team_details?.team_contribution)} Calories
                          </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                        </div>) :
                        (<div className="challengeDetails profileSubContainer">
                          <ChallengeTypeContainer isBackgroundColor="#DA6C74">{DisatanceIcon()}</ChallengeTypeContainer>

                          {isNull(challenge?.team_challenge_details?.team_details?.team_position) ? <div className="rankText">Rank: 0</div> :
                            (today < startDay) ? <div className="rankText">-</div> :
                              <div className="rankText">Rank: {challenge?.team_challenge_details?.team_details?.team_position}{rankingDashboard(challenge?.team_challenge_details?.team_details?.team_position - 1)}</div>}

                          <div className="challengeTypesUnit"> {challenge?.team_challenge_details?.team_details?.team_contribution !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{DistanceUnit === "KILOMETER" ? `${commaSeperator(convertMilesToKm(challenge?.team_challenge_details?.team_details?.team_contribution))} Km` : `${commaSeperator(challenge?.team_challenge_details?.team_details?.team_contribution)} Miles`}
                          </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                        </div>)}
                  </div>

                  :

                  (challenge.challenge_status === 'joined' || challenge.challenge_status === 'over') && !isEmpty(challengeCompetitors) && challenge.event_type === 'Total Steps' ?
                    (<div className="challengeDetails profileSubContainer">
                      <ChallengeTypeContainer isBackgroundColor="#92A4DA" >{StepsIcon()}</ChallengeTypeContainer>
                      <div className="challengeTypesUnit"> {challengeCompetitors['steps'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challengeCompetitors['steps'])} Steps
                      </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                    </div>) :
                    challenge.event_type === 'Total Calories' ?
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#B1AA56">{CaloriesIcon()}</ChallengeTypeContainer>
                        <div className="challengeTypesUnit">  {challengeCompetitors['calories'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challengeCompetitors['calories'])} Calories
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>) :
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#DA6C74">{DisatanceIcon()}</ChallengeTypeContainer>
                        <div className="challengeTypesUnit"> {challengeCompetitors['distance'] !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{DistanceUnit === "KILOMETER" ? ` ${commaSeperator(convertMilesToKm(challengeCompetitors['distance']))} Km ` : ` ${commaSeperator(challengeCompetitors['distance'])} Miles`}
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>)
              }

              <div className="goalToAcheiveConatiner">
                <div className="goalText">Company goal to achieve</div>
                <div className="goalAcheivedText">{activityType === 'distance' ? DistanceUnit === "KILOMETER" ? commaSeperator(convertMilesToKm(TeamDetails['team_goal'])) : commaSeperator(TeamDetails['team_goal']) : commaSeperator(TeamDetails['team_goal'])}<span className="steps"> {activityType === 'distance' ? DistanceUnit === "KILOMETER" ? "Km" : 'Miles' : activityType === 'steps' ? 'Steps' : 'Calories'}</span></div>
              </div>

              <div className="CharityProgressBarContainer">
                <div className="headerConatiner">
                  <div>Progress</div>
                  <div>100% to hit company goal</div>
                </div>
                <CharityProgressBar>
                  <CharityProgressBarFill isFilled={`${TeamDetails['percentage']}%`}>
                    <div className="text">{TeamDetails['percentage'] > 5 ? TeamDetails['percentage'] + "%" : null}</div>
                  </CharityProgressBarFill>
                </CharityProgressBar>
              </div>
            </ProfileContainer>}

          <div className="detailsContainer">
            <ManagerIconContainer isBehaviour={"default"}>{CalendarChallengeIcon()}</ManagerIconContainer>
            <div className="challengeDetails"> {(lang != "fr") ? (convertMonthFromDate(moment(convertDateInTimezone(challenge?.start_date)._d).format('ddd, Do MMM YYYY'), t)) : (convertMonthFromDate(moment(convertDateInTimezone(challenge?.start_date)._d).format('ddd, Do MMM YYYY'), t))} - {(lang != "fr") ? (convertMonthFromDate(moment(convertDateInTimezone(challenge?.end_date)._d).format('ddd, Do MMM YYYY'), t)) : (convertMonthFromDate(moment(convertDateInTimezone(challenge?.end_date)._d).format('ddd, Do MMM YYYY'), t))}</div>
          </div>

          <Divider id="divider" isMargin={"12px 0px"}></Divider>
          <div className="detailsContainer">
            <ManagerIconContainer isBehaviour={"default"}>{LocationChallengeIcon()}</ManagerIconContainer>
            <div className="challengeDetails">{challenge?.challenge_location}</div>
          </div>

          {challenge?.challenge_point ? <><Divider id="divider" isMargin={"12px 0px"}></Divider>
            <div className="detailsContainer">
              <ManagerIconContainer isBehaviour={"default"}>{RewardsChallengeIcon()}</ManagerIconContainer>
              <div className="challengeDetails">+{challenge?.challenge_point} Points</div>
            </div></> : null}

          <Divider id="divider" isMargin={"12px 0px"}></Divider>
          {challenge.is_team_challenge === 1 ? (<> <div className="detailsContainer">
            <ManagerIconContainer isBehaviour={"default"}>{PeopleChallengeIcon()}</ManagerIconContainer>
            <div className="challengeDetails" >{challenge?.team && challenge?.team?.length} {(challenge?.team && challenge?.team?.length) > 1 ? "Teams" : " Team"}</div>
          </div>  <Divider id="divider" isMargin={"12px 0px 28px 0px"}></Divider></>)
            : (challengeAttendees?.length > 0 ? ( <> <div className="detailsContainer">
              <ManagerIconContainer isBehaviour={"default"}>{PeopleChallengeIcon()}</ManagerIconContainer>
              <div className="challengeDetails" >{challengeAttendees && challengeAttendees?.length} {(challengeAttendees && challengeAttendees?.length) > 1 ? "Attendees" : " Attendee"}</div>
            </div>  <Divider id="divider" isMargin={"12px 0px 28px 0px"}></Divider></>):null)}

          {(challenge.is_joined === 0 && Last_Day !== null) ? <div className="lasDay">The last day to join this challenge is {Last_Day}.</div> : null}
          {(challenge.challenge_status === 'joined' && challenge.is_user_challenge && !isEmpty(challengeCompetitors) && challengeCompetitors) ? <div className="jointButton" onClick={() => showHideInviteAmigoPopup()}>
            <div>{InviteChallengeIcon()}</div>
            <div>Invite Friends</div>
          </div> : null}
          {challenge.challenge_status === 'over'?null: ((role==="WELLNESS_ADMIN" || role==="CONTENT_CREATOR" && challenge?.challenge_status === 'joined') || (role ==="ADMIN")) && tabValue === 2 && hasCompanyInRoute && !challenge?.is_user_challenge && <HoverIconWrapper justify="space-between" margin="28px 0 0 0">
            <CommonButtonBorder onClick={challenge.is_team_challenge?()=>onAddUserPopup('Add', 'team'):  ()=>onAddUserPopup('Add')}>{AddUserIcon()}{challenge.is_team_challenge?"Add Team":"Add User"}</CommonButtonBorder>
            <CommonButtonBorder onClick={challenge.is_team_challenge?()=>onAddUserPopup('Remove', 'team'):()=>onAddUserPopup('Remove')}>{RemoveUserIcon()}{challenge.is_team_challenge?"Remove Team": "Remove User"}</CommonButtonBorder>
          </HoverIconWrapper>}
          <Suspense fallback={<Waiting/>}><InviteAmigoPopUp userId={userId} history={history} showModal={showInviteAmigoPopup} onHide={showHideInviteAmigoPopup} challengeId={challenge.id} plusAmigoButton={1} hideInviteAmigoPopup={hideInviteAmigoPopup}/></Suspense>
        </CommonRightCard>
      </>
    )
  }
}


CharityChallengeRightScreen.propTypes = {
  challenge: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
  history: PropTypes.object,
  tabValue: PropTypes.number,
  onAddUserPopup: PropTypes.func,
  challengeDetails: PropTypes.object,
  getUserOverviewDetails: PropTypes.func.isRequired,
  role: PropTypes.string,
  hasCompanyInRoute: PropTypes.bool
};

export default CharityChallengeRightScreen;
